export interface ITwitterData {
    id: string | null,
    username: string | null,
}

export function instanceOfTwitterData(data: any): data is ITwitterData {
    return 'id' in data && 'username' in data;
}
